import { driveFormat } from '@blpde/connect';

export function joinDrivePath(dir: string, name: string): string {
  const left = dir.replace(/^\/+|\/+$/g, '');
  const right = name.replace(/^\/+/, '').replace(/\/+$/, '');
  return [left, right].filter(Boolean).join('/');
}

export function splitDrivePath(path: string): { dir: string; name: string } {
  const parts = path.replace(/^\/+/, '').split('/').filter(Boolean);
  const name = parts.pop() ?? '';
  return { dir: parts.join('/'), name };
}

export function parentDrivePath(path: string): string {
  return splitDrivePath(path).dir;
}

export function matchesExtension(name: string, accept?: readonly string[]): boolean {
  if (!accept || accept.length === 0) return true;
  const lower = name.toLowerCase();
  return accept.some((raw) => {
    const ext = raw.trim().toLowerCase().replace(/^\*/, '');
    if (!ext) return true;
    return lower.endsWith(ext.startsWith('.') ? ext : `.${ext}`);
  });
}

export function ensureExtension(name: string, accept?: readonly string[]): string {
  const trimmed = name.trim();
  if (!trimmed) return trimmed;
  if (matchesExtension(trimmed, accept)) return trimmed;
  const first = accept?.[0]?.trim().replace(/^\*/, '');
  if (!first) return trimmed;
  const ext = first.startsWith('.') ? first : `.${first}`;
  return `${trimmed}${ext}`;
}

export function mimeForName(name: string, fallback = 'application/octet-stream'): string {
  return driveFormat(name)?.mediaType ?? fallback;
}
